module.exports = __webpack_public_path__ + "static/media/prionto.1e53e0c8.png";